export class User {
    Office:Office;
    OfficeId:number;
    RoleId:string;
    RoleName:string;
    KHB_UserId:number;
    UserName:string;
    Password:string;
    ConfirmPassword:string;
}

export class Register {
 
    OTP: string;
      // UserName:string;
      FirstName:string;
      LastName:string;
      PhoneNumber:number;
      Address:any;
      Email:string;
      District:string;
      State:string;
      Password:string;
  }

export class Login {
    UserName:string;
    Password:string;
    OTP:string;
}
export class Office {
    OfficeId:number;
    OfficeCode:string;
    OfficeName:string;
    OfficeType:string;
    Address:string;
    pincode:string;
    TinNo:string;
    Email:string;
    PhoneNumber:number;
}

export class Search{
    SearchCriteria:string;
    SearchText:string;
    SearchRows:number;
}

export class Password{
    oldPassword:any;
    NewPassword:any;
    confirmPassword:any;
}

export class Application{
    ApplicationNo:any;
    FormType:any;
    PropertyType:any;
    ApplicantImage:any;
    DistrictCode:any;
    DistrictName:string;
    ProjectPlace:string;
    NotificationNo:any;
    ApplicantName:string;
    DateofBirth:any;
    Age:any;
    Gender:any;
    GuardianName:any;
    Address:any;
    TelephoneNumber:any;
    MobileNumber:any;
    Email:any;
    Category:any;
    AnnualIncome:any;
    ItPanNo:any;
    BankName:any;
    AccountNumber:any;
    IFSCCode:any;
    SiteDetails:any;
}

export class AccountHeadDetails
{
    AccountHead :number;
	LinkAccount :string;
	AccountName : string;
    UpdatedUserCode : string;
	UpdatedTime : Date;
    inactive:string;
}
export class AccountSubHeadDetails
{
    AccountHead :number;
    AccountSubHead:number;	
	SubHeadName : string;
    UpdatedUserCode : string;
	UpdatedTime : Date;
    inactive:string;
}

export class Expenditure {
    TransactionDate : Date;
    AccountHead:number;
    AccountSubHead:number;
    CashBookCategory:string;
    TransactionType:string;
    InstrumentType:string;
    InstrumentNumber:string;
    InstrumentDate:Date;
    Particulars:string;
    Amount:string;
    FundType:string;
    UpdatedUserID:string;
    UpdatedDate:Date;
    inactive:string;
}

export class CreatePasswordModel{
    UserId:string;
    NewPassword:string;
    ConfirmPassword:string;
}
export class SainikSchemesModel{
    ID :number;
    Scheme_Category: string;
    Scheme_Name : string;
    Inactive : string;
    Last_Edited_UserName: string;
}
export class SainikSchemeApplicationModel{
    ID :number;
    Scheme_Id : number;
    Scheme_Category : string;
    Sainik_UserName: string;
    ApplicationAssignedToUserId : string;
    ApplicationStatus : string;
    UpdatedUserCode: string;
    AppliedDate:Date;
    ApplicationApprovalAssignedOn : Date;
    FromUser:string;
    ToUser:string;
}
export class SainikSchemeApplicationStatusHistoryModel
{
    ID :number;
    ApplicationId:number;
    Status:string;
    StatusId:number;
    AssignedToUserName:string;
    AssignedOn:Date;
    OfficeName:string;
    AssignedToUserRole:string;
    Comments: string;
    OfficeLevel: string;
    OfficeId: number;   
}
export class CorrespondanceTrackingModel {
    Id : number;
    InwardNumber : string;
    OutwardNumber : string;
    CorrespondenceDescription : string;
    ScannedDocument : string;
    DetailsTime : string;
    AssignedTo : string;
    Status : string;
    InwOuwRadioBtn : string;
    InwardOrOutWard : string;
    CheckRadio : string;
}
export class GrievancesLodging
{
    SainikUserName :string;
    ScanDocument: string;
    GrievanceType:string;
    Description:string;
    status:string;
    ActionStatus:string;
    ActionTaken:string;
    ActionTakenHis:string;
    SER_Name:string;
    CA_Name:string;
    SR_Name:string;
    SR_SurName:string;
}


// WEBPACK FOOTER //
// ./src/app/shared/user.model.ts